import React from "react";
import VirtualTable from "../../../components/custom/VirtualTable";
import { IssuedRow } from "./types";
import { EmptyState } from "./shared";

interface IssuedViewProps {
    issued: IssuedRow[];
    onRowClick: (row: IssuedRow) => void;
}

export default function IssuedView({ issued, onRowClick }: IssuedViewProps) {
    if (issued.length === 0) {
        return <EmptyState title="Nothing issued yet" body="Assigned inventory will show up here, grouped by recipient." />;
    }

    return (
        <VirtualTable<IssuedRow>
            data={issued}
            mapping={[
                { name: "Name", value: "name" },
                { name: "Email", value: "email", email: true },
                { name: "Item assigned", value: "itemName" },
                { name: "Quantity assigned", value: "quantityAssigned", number: true },
                { name: "Attributes", value: "attributeSummary" },
            ]}
            handleClick={(row) => onRowClick(row as IssuedRow)}
        />
    );
}
